<template>
    <footer class="bg-shade pt-9 px-5 xl:px-[14vw] gap-x-6 flex sm:flex-col justify-between">
        <div >
            <a href="/dashboard" title="Página Inicial">
            <div class="flex flex-col items-center gap-y-2">
              <div>
                  <img src="/images/slogan.png" class="max-w-[150px] w-full" />
              </div>
                <div class="max-w-[260px] ml-[30px]">
                    <img src="/images/logo.png" />
                </div>
            </div>
                <!-- <img src="/images/logo-bb.png" class="max-w-[143px] xl:hidden sm:self-center"  /> -->
            </a>
        </div>

        <div class="text-white">

            <div v-if="!auth" class="flex sm:flex-col text-white gap-x-7 text-[14px] sm:leading-10 pb-7 pt-3">
                <a v-for="link in getLink" :key="link.text" :href="route(link.url)">{{link.text}}</a>
            </div>

            <div v-if="auth" class="flex gap-x-7 gap-y-4 sm:flex-col text-white text-lg whitespace-nowrap sm:mt-8">
                <a :href="route('privacy')">Privacidade</a>
                <a :href="route('terms')" class="whitespace-nowrap">Termos de Uso</a>
                <a :href="route('regulation')">Regulamento</a>
                <a @click="showModalPrivacy = true" class="cursor-pointer">Minha Privacidade</a>
            </div>
        </div>

        <div class="grid gap-y-3 pb-10 gap-x-18 max-w-[326px] sm:max-w-full sm:mt-20">
            <a href="/contact"
                class="max-w-[136px] whitespace-nowrap text-primary font-semibold bg-white border rounded-2xl hover:bg-gray-200
                  hover:border transparent hover:text-primary p-4 sm:mt-2">
                Fale Conosco
            </a>
                <p class="text-[14px] text-white">Fale com um agente de suporte:</p>
            <div>
                <!-- <p class="text-[14px] text-white font-bold">0800-0000 (Capitais e grandes centros)</p>
                <p class="text-[14px] text-white font-bold">0800-0001 (Demais cidades e regiões)</p> -->
                <p class="text-[14px] text-white font-bold">0800 750 5548</p>
            </div>
            <div>
                <p class="text-[14px] text-white">Atendimento disponível de segunda a sexta, das 10h às 17h (horário de Brasília).</p>
            </div>


      <!-- <span v-for="(description, name) in medias" :key="name">
        <SocialMedia :description="description">
          <Icon :name="name" />
        </SocialMedia>
      </span> -->
    </div>
    <transition>
        <div v-if="showModalPrivacy" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-50 flex justify-center items-center px-5">
            <div class="relative bg-white border-[1px] border-primary rounded-[4px] py-2.5 px-4 max-w-[536px]">
                <button class="absolute right-0 top-0 m-1.5" @click="showModalPrivacy = false">
                    <Icon name="Fechar"/>
                </button>
                <h1 class="text-xl font-bold text-primary">Minha Privacidade</h1>
                <p class="mt-2.5">Data Protection Officer (DPO) é o profissional encarregado de informar, aconselhar e controlar o tratamento dos dados,
                    a respeito das obrigações do site nos termos da Lei de Proteção de Dados Pessoais e de outras disposições de proteção de dados presentes na legislação nacional,
                    em cooperação com a autoridade de controle competente.</p>
                    <br>
                <p>Caso queira revogar alguma autorização, realizar alguma exclusão ou esclarecer uma dúvida sobre o tratamento de suas informações pessoais,
                    envie por e-mail as seguintes informações:</p>
                <ul class="flex flex-col font-bold text-gray-600 mt-9">
                    <li>• Seu nome</li>
                    <li>• CPF</li>
                    <li>• Motivo do Contato</li>
                </ul>
                <div>
                    <p class="font-bold text-primary">
                        Nome do DPO: Isabella Leite <br>
                        Enviar para: dpo@eficienciavenca.com.br
                    </p>
                </div>
            </div>
        </div>
    </transition>
  </footer>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import SocialMedia from "@/Components/UI/Icons/SocialMedia.vue";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Icon,
    SocialMedia,
    ApplicationLogo,
    Link,
  },
  props: {
    auth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        showModalPrivacy: false,
        medias: {
            Youtube: "YouTube",
            Instagram: "Instagram",
            Whatsapp: "WhatsApp",
            Facebook: "Facebook",
            TikTok: "Tiktok",
            Twitter: "Twitter",
        },

        links: [
            {
            url: "privacy",
            text: "Privacidade",
            },
            {
            url: "terms",
            text: "Termos de uso",
            },
        ],
    }
  },
  computed: {
    getLink() {
      if (this.auth) {
        return this.linksAuth;
      } else {
        return this.links;
      }
    },
  },
}

</script>
